<template>
    <vl-map
        ref="map"
        :load-tiles-while-animating="true"
        :load-tiles-while-interacting="true"
        data-projection="EPSG:4326"
        style="height: 100vh"
        class="h-screen"
        :wrap-x="false"
    >
        <vl-view
            ref="view"
            :zoom.sync="zoom"
            :center="currentcenter"
            :rotation.sync="rotation"
        ></vl-view>
        <vl-layer-tile id="osm">
            <vl-source-osm :wrap-x="false"></vl-source-osm>
        </vl-layer-tile>
        <vl-feature
            v-for="(point, index) in mapPoints"
            :key="index"
            :properties="{ id: point[0], type: 'competitor' }"
        >
            <vl-geom-point :coordinates="[point[1], point[2]]"></vl-geom-point>
            <vl-style-box>
                <vl-style-circle :radius="10">
                    <vl-style-fill :color="point[3]"></vl-style-fill>
                    <vl-style-stroke :color="point[4]" :width="2"></vl-style-stroke>
                </vl-style-circle>
            </vl-style-box>
        </vl-feature>
        <!-- Path -->
        <vl-feature :properties="{ id: 'river-path' }" key="river-path">
            <vl-geom-line-string color="#FF00FF" :coordinates="pathData" id="pathid">
            </vl-geom-line-string>
            <vl-style-box>
                <vl-style-fill color="white"></vl-style-fill>
                <vl-style-stroke color="#01577D" :width="5"></vl-style-stroke>
            </vl-style-box>
        </vl-feature>
        <!-- /Path -->
        <!-- Specific Crew Paths -->
        <vl-feature
            v-for="(crew, index) in crewPaths"
            :key="`${index}-crew-path`"
            :properties="{ id: `${index}-crew-path` }"
        >
            <vl-geom-line-string :color="crew[0]" :coordinates="crew[1]" :id="`${index}-crew-path`">
            </vl-geom-line-string>
            <vl-style-box>
                <vl-style-fill :color="crew[0]"></vl-style-fill>
                <vl-style-stroke :color="crew[0]" :width="5"></vl-style-stroke>
            </vl-style-box>
        </vl-feature>
        <!-- /Specific Crew Paths -->
        <!-- Points of Interest -->
        <template v-if="zoom > 11">
            <vl-feature
                v-for="interestPoint in pointsOfInterest"
                :key="interestPoint.id"
                :properties="{ id: interestPoint.id, type: 'pointOfInterest' }"
            >
                <vl-geom-point
                    :coordinates="[interestPoint.longitude, interestPoint.latitude]"
                ></vl-geom-point>
                <vl-style-box>
                    <vl-style-icon
                        src="https://assets.website-files.com/6178c347c92cfe64cb720a77/6191dbd41bfe9196d86a5290_POI%20Location.png"
                        :scale="0.05"
                        :anchor="[1, 1]"
                        :size="[860, 593]"
                    ></vl-style-icon>
                </vl-style-box>
            </vl-feature>
        </template>
        <!-- Points of Interest -->
        <!-- start flags -->
        <vl-feature :properties="{ id: 'start-finish-flag', type: 'flag' }">
            <vl-geom-point :coordinates="[-0.07427, 51.50502]"></vl-geom-point>
            <vl-style-box>
                <vl-style-icon
                    :src="
                        'https://assets.website-files.com/625740b496a36ec42969c9b9/627861e4bf9f5709805d15a3_start%20finish%20flag-p-500.png'
                    "
                    :scale="0.09"
                    :anchor="[0.25, 0.92]"
                    :size="[860, 593]"
                ></vl-style-icon>
            </vl-style-box>
        </vl-feature>
        <!-- end start flags -->
        <!-- Popover -->
        <vl-interaction-select :features.sync="selectedFeatures">
            <template slot-scope="select">
                <!-- selected feature popup -->
                <vl-overlay
                    class="feature-popup"
                    v-for="feature in select.features"
                    :key="feature.id"
                    :id="feature.id"
                    :position="pointOnSurface(feature.geometry)"
                    :auto-pan-animation="{ duration: 300 }"
                    :auto-pan="true"
                >
                    <template>
                        <TeamCard
                            v-if="feature.properties.type === 'competitor'"
                            style="width: 22.5rem;"
                            :event="events.filter(item => item.id == feature.properties.id)[0]"
                        ></TeamCard>
                        <PointOfInterestCard
                            v-if="feature.properties.type === 'pointOfInterest'"
                            style="width: 22.5rem;"
                            :point="
                                pointsOfInterest.filter(item => item.id == feature.properties.id)[0]
                            "
                        ></PointOfInterestCard>
                    </template>
                </vl-overlay>
                <!--// selected popup -->
            </template>
        </vl-interaction-select>
        <!-- Popover -->
    </vl-map>
</template>
<script>
import { findPointOnSurface } from 'vuelayers/lib/ol-ext'
import TeamCard from './TeamCard'
import PointOfInterestCard from './PointOfInterestCard'
import pathData from './path.js'
import pointsOfInterest from './points_of_interest.js'
export default {
    name: 'Map',
    props: ['mapView', 'currentcenter', 'locations', 'events', 'paths'],
    components: {
        TeamCard,
        PointOfInterestCard,
    },
    data() {
        return {
            zoom: 6,
            rotation: 0,
            selectedFeatures: [],
            pathData: pathData,
            pointsOfInterest,
        }
    },
    methods: {
        pointOnSurface: findPointOnSurface,
    },
    computed: {
        mapPoints: function() {
            return this.locations
        },
        crewPaths: function() {
            let pathDict = {}
            this.paths.map(item => {
                const keys = Object.keys(item)
                keys.map(key => {
                    if (key in pathDict) {
                        pathDict[key].push(
                            item[key]
                                .slice(1, -1)
                                .split(',')
                                .map(Number)
                                .reverse()
                        )
                    } else {
                        pathDict[key] = [
                            item[key]
                                .slice(1, -1)
                                .split(',')
                                .map(Number)
                                .reverse(),
                        ]
                    }
                })
            })
            let transformed = []
            for (const pathItem in pathDict) {
                transformed.push([pathItem, pathDict[pathItem]])
            }
            return transformed
        },
    },
    watch: {
        mapView: function() {
            this.$refs.map.refresh()
            this.$refs.view.refresh()
            this.$refs.map.updateSize()
        },
        locations: function() {
            this.$refs.map.refresh()
            this.$refs.map.updateSize()
        },
        mapPoints: function() {
            this.$refs.map.refresh()
            this.$refs.map.updateSize()
        },
    },
}
</script>
